<template>
  <div class="layer">
    <highSearch @highSearch="highSearch"></highSearch>
    <!-- 该关键词如果还有另外一种类型则显示并且可以跳转 -->
    <div class="revMeaning width" v-if="nameData.typedata[0].show">
      <div class="mean width">
        {{nameData.typedata[0].name}}是一个多义词，当前检索类型为
        <el-link type="primary" :underline="false">人名</el-link>，
        其他检索类型有：
        <el-link
          type="primary"
          :underline="false"
          @click="othertype"
        >{{nameData.typedata[0].othertype?'机构':'研究方向'}}</el-link>
      </div>
    </div>
    <!-- 主体 -->
    <div class="retrieval width">
      <left
        :topSubjects="nameData.data.topSubjects"
        :topKeywords="topKeywords"
        :topOrganizations="nameData.data.topOrganizations"
        :isLeftClick="loading1"
        @screenData="getScreen"
        form="name"
      ></left>
      <div class="info">
        <div class="search-r">
          <div class="menu clearfix">
            <h4
              v-if="!user"
            >{{intercept ? '已经为您检索到'+nameData.data.total+'条，游客显示前100条，登录可以查看更多。':'已经为您检索到'+nameData.data.total+'条。'}}</h4>
            <h4
              v-else
            >{{ intercept ? '已经为您检索到'+nameData.data.total+'条，当前状态下展示为前1000条，如需更多数据请与项目组联系。': '已经为您检索到'+nameData.data.total+'条。'}}</h4>
            <div class="showway">
              <span>展示格式</span>
              <img @click="index=2" class="listimg" src="static/img/icon/list.png" alt />
              <img @click="index=1" src="static/img/icon/nine.png" alt />
            </div>
          </div>
          <div v-show="index===1" class="res-list clearfix" v-loading="loading1">
            <div
              class="exp-box"
              :style="{width:expWidth}"
              v-for="(item,index) in nameData.data.obj"
              :key="index"
            >
              <div class="exp-int clearfix">
                <el-image
                  @click="goDetail(item,index)"
                  class="exp-header"
                  :src=" item.avatar || (item.avatarUrl?'/old/public'+item.avatarUrl:'')"
                  fit="contain"
                >
                  <div slot="placeholder" class="image-slot">
                    <img
                      width="80px"
                      height="100px"
                      src="http://expert.ckcest.cn/autoload/images/avatar.png"
                    />
                  </div>
                  <div slot="error" class="image-slot">
                    <img
                      width="80px"
                      height="100px"
                      src="http://expert.ckcest.cn/autoload/images/avatar.png"
                    />
                  </div>
                </el-image>
                <div class="exp-textint">
                  <h5
                    @click="goDetail(item,index)"
                  >{{item.name}} {{!item.honor?item.honor:item.honor.slice(0,10)+'...'}}</h5>
                  <p :title="item.organization">{{item.organization}}</p>
                  <p>{{/^[0-9]+$/.test(item.kId) ? (item.claimType == 0?'机器认领':(item.claimType == 1?'本人认领':'人工认领')) : '未认领'}}</p>
                </div>
              </div>
              <p
                class="isni"
                v-if="item.isni"
              >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3)}}</p>
              <p class="isni" v-else></p>
              <p
                class="subject"
                :title="item.subject"
                v-if="item.subject && item.subject !== ' '"
              >学科：{{item.subject}}</p>
              <p class="subject" v-else></p>
              <ul class="keywords clearfix" style="background-color: #f5f5f5;" v-if="item.keyword">
                <li v-for="li in item.keywordList" :key="li">{{li}}</li>
              </ul>
              <ul class="keywords clearfix" v-else></ul>
            </div>
          </div>
          <div v-show="index===2" class="res-listelse" v-loading="loading1">
            <ul>
              <li class="clearfix" v-for="( item, index ) in nameData.data.obj" :key="index">
                <div class="eles-info">
                  <div class="else-header">
                    <el-image
                      @click="goDetail(item,index)"
                      class="exp-header"
                      :src="item.avatar || (item.avatarUrl?'/old/public'+item.avatarUrl:'')"
                      fit="contain"
                    >
                      <div slot="placeholder" class="image-slot">
                        <img
                          width="100%"
                          height="100%"
                          src="http://expert.ckcest.cn/autoload/images/avatar.png"
                        />
                      </div>
                      <div slot="error" class="image-slot">
                        <img
                          width="100%"
                          height="100%"
                          src="http://expert.ckcest.cn/autoload/images/avatar.png"
                        />
                      </div>
                    </el-image>
                  </div>

                  <div class="else-int">
                    <h5
                      @click="goDetail(item,index)"
                      style="color:#879b86"
                    >{{item.name}} {{item.honor}}</h5>
                    <p style="color:#879b86" :title="item.organization">{{item.organization}}</p>
                    <p>{{/^[0-9]+$/.test(item.kId) ? (item.claimType == 0?'机器认领':(item.claimType == 1?'本人认领':'人工认领')) : '未认领'}}</p>
                    <p
                      v-if="item.isni"
                    >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3) }}</p>
                    <p style="min-height:20px" v-else></p>
                    <p
                      class="subject"
                      :title="item.subject"
                      v-if="item.subject && item.subject !== ' '"
                    >学科：{{item.subject}}</p>
                    <p class="subject" v-else></p>
                    <div class="else-keywords" v-if="item.keyword">
                      <span>研究方向：</span>
                      <a v-for="li in item.keywordList" :key="li">{{li ? li :'无'}}</a>
                    </div>
                    <div class="else-keywords" v-else></div>
                  </div>
                  <ul class="elseinttext">
                    <li
                      v-if="item.introduction"
                      class="elseinttext-item"
                    >{{item.introduction.trim() }}</li>
                  </ul>
                </div>
                <div class="else-chart" v-if="!loading2">
                  <FoldBarChart
                    :foldList="item.foldList || {}"
                    style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
                  ></FoldBarChart>
                </div>
                <div v-else class="else-chart" v-loading="loading2"></div>
              </li>
            </ul>
          </div>
        </div>
        <pagination
          :total="user?(nameData.data.total>1200?1200:nameData.data.total):(nameData.data.total>120?120:nameData.data.total)"
          :page.sync="pageData.PageIndex"
          :limit.sync="pageData.PageSize"
          :pageSizes="pageSizes"
          :layout="layout"
          @pagination="getPage()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import highSearch from "@/components/common//highSearch";
import left from "@/components/commonrRetrieve/left";
import FoldBarChart from "@/components/Charts/FoldBarChart";
import { getQueryAcademicStats } from "@/api/retrieveName";
import { getBase64Avatar } from "@/api/center";
import { isNum } from "@/utils/index";
import { search } from "@/api/common";
import { checkReplacePath } from "@/utils/index";
export default {
  name: "RetrieveName",
  components: {
    Pagination,
    left,
    highSearch,
    FoldBarChart
  },
  watch: {
    index: {
      deep: true,
      handler(val) {
        if (val === 1) {
          this.pageData.PageSize = 16;
          this.pageData.PageIndex = this.pageIndex2;
          this.pageSizes = [16];
        } else {
          this.pageData.PageSize = 4;
          this.pageData.PageIndex = this.pageIndex1;
          this.pageSizes = [4];
        }
        this.getPage();
      }
    },
    screenWidth: function(val) {
      this.changeExpWidth(val);
    }
  },
  data() {
    return {
      index: 2, // 当前布局
      nameData:
        this.$route.params.data === undefined
          ? JSON.parse(localStorage.getItem("nameData"))
          : this.$route.params.data, // 传入参数
      user: localStorage.getItem("user"),

      /* 分页 */
      layout: "prev, pager, next, jumper",
      pageData: {
        No: "",
        Name: "",
        PageSize: 4,
        PageIndex: 0
      }, // 分页信息
      fieldDataParams: JSON.parse(localStorage.getItem("fieldDataParams")),
      intercept: false,
      screenData: {}, // 左侧栏返回数据
      pageSizes: [4], // 每页数量
      pageIndex1: 0, // 密集布局当前页
      pageIndex2: 0, // 单行布局当前页
      loading1: false, // 加载动画1
      loading2: false, // 加载动画2
      k: "",
      topKeywords: [], // 研究主题
      expWidth: "23%", // 专家宽度
      screenWidth: document.documentElement.clientWidth // 屏幕宽度
    };
  },
  async mounted() {
    var _this = this;
    this.changeExpWidth(this.screenWidth);
    window.onresize = function() {
      // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth; // 窗口宽度
    };
    let str = "";
    this.fieldDataParams = this.nameData.typedata.map(item => {
      str += item.name + " ";
    });
    this.fieldDataParams.k =
      str.length > 1 ? str.substring(0, str.length - 1) : "";

    localStorage.setItem("nameData", JSON.stringify(this.nameData));
    this.init();
  },
  methods: {
    goDetail(data, index) {
      let query = {};
      if (/^\d+$/.test(data.kId)) {
        query.kId = data.kId;
      } else {
        query.name = data.name;
        query.institute = data.institute || data.organization;
      }
      // query: /^\d+$/.test(item.kId)? {kId:item.kId } :{name:item.name,institute:item.organization}
      query.k = this.fieldDataParams.queryk
        ? this.fieldDataParams.queryk.join(" ")
        : this.fieldDataParams.k;
      if (query.keyword == query.k) {
        delete query.k;
      } else {
        if(this.nameData.typedata[0].type == 0){
          query.keyword = query.k;
        }
        delete query.k;
      }
      localStorage.setItem("val", query.keyword);
      let routeData = this.$router.resolve({ name: "Detail", query: query });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: 'Detail', query: query })
    },
    init(par) {
      this.nameData.data.obj = this.nameData.data.obj.slice(0, 4);
      this.nameData.data.obj.forEach((item, index) => {
        this.getData(item, index);
        this.nameData.data.obj[index].keywordList = item.keyword.split(";");
      });
      let k = "";
      if (par) {
        k = par.k;
      } else {
        let k = "";
        if (
          this.nameData.params.institute &&
          this.nameData.params.institute.length
        ) {
          k = this.nameData.params.institute[0] + " ";
        }
        if (
          this.nameData.params.institute &&
          this.nameData.params.keywords.length
        ) {
          this.nameData.params.keywords.forEach((item, index) => {
            k = k + item + " ";
          });
        }
      }
      this.k = k;
      this.key(0); // 研究主题
    },
    // 根据页面宽度设置宽度
    changeExpWidth(val) {
      if (val > 1480) {
        this.expWidth = "23%";
      } else if (val > 980) {
        this.expWidth = "32%";
      }
    },
    // 研究主题
    key(index) {
      this.topKeywords = [];
      if (this.nameData.data.obj.length) {
        if (this.nameData.data.obj[index].keyword) {
          this.topKeywords = this.topKeywords.concat(
            this.nameData.data.obj[index].keywordList ||
              this.instData.data.obj[index].keyword.split(";")
          );
        } else {
          this.topKeywords = this.topKeywords.concat({});
        }
        if (this.topKeywords.length > 10) {
          this.keys();
        } else {
          this.key(index + 1);
        }
      } else {
        this.topKeywords = [];
      }
    },
    // 研究主题
    keys() {
      let temp = this.topKeywords;
      let data = [];
      temp.forEach((item, index) => {
        if (index > 9) {
          return;
        }
        data.push({
          key: item.key || item
        });
      });

      this.topKeywords = data;
    },

    // 左侧点击事件
    getScreen(data) {
      this.screenData = data;
      this.pageData.PageIndex = 0;
      let par = {};
      if (sessionStorage.getItem("highSearch")) {
        par = JSON.parse(sessionStorage.getItem("highSearch"));
      }
      this.getPage(par);
    },
    async highSearch(params) {
      console.log(params);
      await this.getPage(params, true);
      this.init(params);
    },
    // 检索专家
    async getPage(par = this.fieldDataParams, rest = false) {
      this.setTip();
      this.loading1 = true;
      let index =
        this.pageData.PageIndex - 1 > 0 ? this.pageData.PageIndex - 1 : 0;
      if (rest) {
        this.pageData.PageIndex = 1;
        index = 0;
      }
      let data = {
        k: this.k + this.nameData.params.name,
        ...par,
        from: index * this.pageData.PageSize,
        size: this.pageData.PageSize,
        ...this.screenData
      };
      if (data.next) {
        data.para = this.nameData.data.query;
      }
      if (!par.k) {
        delete data.k;
      }
      if (this.index === 2) {
        this.pageIndex1 = this.pageData.PageIndex;
      } else {
        this.pageIndex2 = this.pageData.PageIndex;
      }
      if (this.screenData && this.$store.state.highSearch) {
        data = Object.assign(data, this.screenData);
      }
      if (!this.$store.state.highSearch) {
        delete data.s;
      }
      this.fieldDataParams = data;
      localStorage.setItem("fieldDataParams", JSON.stringify(data));
      await search(data)
        .then(res => {
          this.loading1 = false;
          if (!res.typedata.length) {
            res.typedata = [{}];
          }
          if (!checkReplacePath(this, res, 1, data, "instData")) {
            this.nameData = res;
            this.keys();
            this.nameData.data.obj.forEach((item, index) => {
              this.getData(item, index);
              if (this.nameData.data.obj[index].keyword) {
                this.nameData.data.obj[
                  index
                ].keywordList = this.nameData.data.obj[index].keyword.split(
                  ";"
                );
              }
              if (
                item.avatarUrl === null ||
                item.avatarUrl === " " ||
                item.avatarUrl === undefined
              ) {
                this.nameData.data.obj[index].avatarUrl = "";
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取专家成果列表
    async getData(item, index) {
      this.loading2 = true;
      let data = {};
      if (isNum(item.kId)) {
        data = {
          excludeBook: true,
          isClaim: "1",
          kId: parseInt(item.kId),
          nameOrgArray: item
        };
      } else {
        let temp = [];
        temp[0] = item;
        data = {
          excludeBook: true,
          isClaim: "0",
          nameOrgArray: temp
        };
      }
      var avatar = "";
      if (!isNaN(item.kId)) {
        await getBase64Avatar({ kId: item.kId }).then(res => {
          avatar =
            res.data[0].data[0] && res.data[0].data[0].avatar
              ? res.data[0].data[0].avatar.replace(/[\r\n]/g, "")
              : "";
        });
      }
      getQueryAcademicStats(data)
        .then(res => {
          this.nameData.data.obj[index].foldList = res.obj.stats1;
          this.nameData.data.obj[index].avatar = avatar; //将检索出来的图片 赋值给对象
          this.nameData.data.obj[index].subject =
            this.nameData.data.obj[index].subject + " ";
          this.loading2 = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 设置检索条数文字
    setTip() {
      this.intercept = false;
      if (this.index === 1) {
        if (this.user) {
          if (this.pageData.PageIndex === 100) {
            this.intercept = true;
          }
        } else {
          if (this.pageData.PageIndex === 10) {
            this.intercept = true;
          }
        }
      } else if (this.index === 2) {
        if (this.user) {
          if (this.pageData.PageIndex === 400) {
            this.intercept = true;
          }
        } else {
          if (this.pageData.PageIndex === 40) {
            this.intercept = true;
          }
        }
      }
    },
    // 其他检索类型
    othertype() {
      let data = this.k + this.nameData.params.name;
      this.$router.push({
        name: "Loading",
        params: { data: data, searchtype: this.nameData.typedata[0].othertype }
      });
    }
  }
};
</script>

<style lang="scss">
.revMeaning {
  height: 80px;
  .mean {
    padding-left: 40px;
    height: 40px;
    background: #fff;
    display: flex;
    align-items: center;
  }
}
.retrieval {
  display: flex;
  flex-direction: row;
  .info {
    width: 68%;
    .search-l {
      .search-list {
        margin-bottom: 10px;
        h3 {
          background-color: #ccc;
          padding: 10px 0 10px 10px;
          font-size: 16px;
          font-weight: 600;
          color: #6f6f6f;
        }
        ul {
          background-color: #f7f7f7;
          li {
            padding: 5px 0 5px 10px;
            color: #6f6f6f;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              background-color: #6f6f6f;
              color: #fff;
            }
          }
        }
      }
    }
    .search-r {
      .menu {
        background: #fff;
        padding: 1em;
        margin-bottom: 15px;
        h4 {
          float: left;
          font-size: 14px;
        }
        .showway {
          float: right;
          span {
            font-size: 12px;
            font-weight: 600;
            vertical-align: text-top;
          }
          img {
            display: inline-block;
            width: 20px;
            height: 20px;
            cursor: pointer;
            margin-left: 5px;
          }
        }
      }
      .res-list {
        min-height: 100vh;
        .exp-box {
          background: #fff;
          float: left;

          margin-right: 1.33%;
          margin-bottom: 1.33%;
          border: 1px #ccc solid;
          padding: 10px;
          .exp-int {
            display: flex;
            flex-direction: row;
            .exp-header {
              width: 80px;
              float: left;
              height: 100px;
              cursor: pointer;
            }
            .exp-textint {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-left: 10px;
              font-size: 12px;
              h5 {
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 10px;
              }
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 5px;
              }
            }
          }
          .isni {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            min-height: 20px;
            font-size: 12px;
            margin-top: 10px;
          }
          .subject {
            min-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
          }
          .keywords {
            height: 44px;
            overflow: hidden;
            margin-top: 5px;
            margin-top: 5px;
            li {
              height: 20px;
              float: left;
              border: 1px #ccc solid;
              padding: 1px 2px;
              border-radius: 4px;
              font-size: 12px;
              margin: 0 4px 2px 0;
            }
          }
        }
      }
      .res-listelse {
        min-height: 100vh;
        ul {
          li {
            ::-webkit-scrollbar {
              width: 6px;
              background-color: #f2f2f2;
            }
            ::-webkit-scrollbar-thumb {
              background-color: #dedede;
            }
            height: 540px;
            padding: 20px;
            background: #fff;
            border: 1px #ccc solid;
            margin-bottom: 10px;
            .eles-info {
              display: flex;
              flex-direction: row;
              .else-header {
                float: left;
                .exp-header {
                  cursor: pointer;
                  display: block;
                  width: 120px;
                  height: 160px;
                  margin-right: 15px;
                }
              }
              .else-int {
                cursor: pointer;
                float: left;
                margin-right: 15px;
                h5 {
                  font-size: 14px;
                }
                p {
                  width: 300px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-size: 12px;
                  margin-top: 10px;
                }
                .else-keywords {
                  width: 300px;
                  height: 48px;
                  overflow: hidden;
                  margin-top: 10px;
                  span,
                  a {
                    font-size: 12px;
                  }
                  a {
                    height: 20px;
                    margin: 0 5px 4px 0;
                    display: inline-block;
                    border: 1px #ccc solid;
                    padding: 2px 4px;
                    border-radius: 4px;
                  }
                }
              }
            }
            .else-chart {
              height: 300px;
              margin-top: 30px;
            }
            .elseinttext {
              float: left;
              width: 60%;
              font-size: 12px;
              overflow: auto;
              height: 200px;
              text-indent: 2em;
              .elseinttext-item {
                border: none;
                margin-bottom: 0;
                height: 200px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/RetrieveName.vue